export default __webpack_public_path__ + "static/media/25.5e3b97bc.jpg";